import gql from 'graphql-tag';

import { getSingleProp, unwrapEdges } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { FRAGMENT_FACEBOOK_VARIATION_RESULT } from './schema';

const QUERY = gql`
  query LastFbExtractRequest(
    $projectId: ID!
    $assetType: AssetTypeEnum!
    $insightsIntervalDays: Int
  ) {
    lastFbExtractRequest(
      projectId: $projectId
      assetType: $assetType
      insightsIntervalDays: $insightsIntervalDays
    ) {
      adAccountFbId
      filterByUrl
      facebookVariationResults {
        edges {
          node {
            ...FacebookVariationResult
          }
        }
      }
    }
  }
  ${FRAGMENT_FACEBOOK_VARIATION_RESULT}
`;

export const queryFacebookLastExtractRequest = ({ projectId, assetType, insightsIntervalDays }) => {
  return apolloClient
    .query({
      query: QUERY,
      variables: { projectId, assetType, insightsIntervalDays },
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => getSingleProp(data))
    .then((result) => {
      if (!result) {
        return null;
      }

      return {
        adAccountId: result.adAccountFbId,
        filterByUrl: result.filterByUrl,
        ads: unwrapEdges(result.facebookVariationResults.edges),
      };
    });
};
